import styled from '@emotion/styled';

import { textareaBaseStyles } from '@/components/common/form/controlStyles';

interface TextareaProps {
	isError?: boolean;
	$minHeight?: string;
}

export const Container = styled.div`
	position: relative;
	width: 100%;
`;

export const TextareaInput = styled.textarea<TextareaProps>`
	${(props) => textareaBaseStyles(props.theme, props.isError)};
	min-height: ${(props) => props.$minHeight ?? '20rem'};
	resize: vertical;
`;
